import axios from "axios"
import { config } from "../utils/config"

/**
 * Instancia de Axios usada por toda la app (se comparte vía utils/context.js).
 *
 * - En modo proxy (producción) NO se envía x-api-key: el secreto lo inyecta la
 *   Azure Function en /api/dashboard/*. En dev sí se manda la key local.
 * - El JWT del usuario se duplica en X-User-Authorization porque Azure Static
 *   Web Apps puede sobrescribir el header Authorization con su token interno.
 *   El proxy lo vuelve a mapear a Authorization antes de llamar al backend.
 *   Se hace en un interceptor para no tener que tocar los ~83 lugares que ya
 *   mandan Authorization por request.
 */
export default function useAxios() {
    const { BASE_URL, API_KEY_NAME, API_KEY_VALUE, USE_PROXY } = config

    const defaultHeader = {}
    if (API_KEY_VALUE) {
        defaultHeader[API_KEY_NAME] = API_KEY_VALUE
    }

    const instance = axios.create({
        baseURL: BASE_URL,
        headers: defaultHeader,
        validateStatus: false
    })

    if (USE_PROXY) {
        instance.interceptors.request.use((requestConfig) => {
            const auth =
                requestConfig.headers?.Authorization ||
                requestConfig.headers?.authorization ||
                requestConfig.headers?.common?.Authorization

            if (auth) {
                requestConfig.headers['X-User-Authorization'] = auth
            }
            return requestConfig
        })
    }

    return { axios: instance }
}
